import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, AlertCircle } from "lucide-react";
import api from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/auth/login", { email, password });
      localStorage.setItem("oc_admin_token", data.access_token);
      localStorage.setItem("oc_admin_email", data.email);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Inloggen mislukt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen oc-hero-gradient flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="bg-white rounded-oc shadow-oc-card-hover p-10 w-full max-w-md"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 text-oc-primary font-display font-bold text-xl">
          <ShieldCheck className="w-6 h-6 text-oc-secondary" />
          OfferteExpert Admin
        </div>
        <h1 className="font-display text-oc-primary font-bold text-[24px] mt-6">Inloggen</h1>
        <p className="text-oc-textSecondary text-[14px] mt-1">Beveiligd toegangspunt voor het admin dashboard.</p>

        <div className="mt-7 space-y-4">
          <div className="space-y-2">
            <Label>E-mailadres</Label>
            <Input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 rounded-oc-btn"
              required
            />
          </div>
          <div className="space-y-2">
            <Label>Wachtwoord</Label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 rounded-oc-btn"
              required
            />
          </div>
          {error && (
            <div className="flex items-start gap-2 text-oc-excessive bg-[rgba(220,38,38,0.06)] border border-[rgba(220,38,38,0.25)] rounded-oc-btn p-3 text-[14px]">
              <AlertCircle className="w-4 h-4 mt-0.5" />
              <span>{error}</span>
            </div>
          )}
          <Button
            data-testid="admin-login-button"
            disabled={loading}
            className="w-full h-12 bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn font-semibold"
          >
            {loading ? "Bezig..." : "Inloggen"}
          </Button>
        </div>
      </form>
    </div>
  );
}
